//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Tools = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Tools"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_24637_141)">
            <path
              d="M0.888794 2.66666H7.99991"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.5555 2.66666H15.1111"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.66663 7.99995C2.66663 8.47144 2.85393 8.92363 3.18732 9.25702C3.52072 9.59042 3.97291 9.77772 4.4444 9.77772C4.9159 9.77772 5.36808 9.59042 5.70148 9.25702C6.03488 8.92363 6.22218 8.47144 6.22218 7.99995C6.22218 7.52845 6.03488 7.07627 5.70148 6.74287C5.36808 6.40947 4.9159 6.22217 4.4444 6.22217C3.97291 6.22217 3.52072 6.40947 3.18732 6.74287C2.85393 7.07627 2.66663 7.52845 2.66663 7.99995Z"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M0.888794 8H2.66657"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.22217 8H15.1111"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.6666 13.3333C10.6666 13.8048 10.8539 14.257 11.1873 14.5904C11.5207 14.9238 11.9729 15.1111 12.4444 15.1111C12.9159 15.1111 13.3681 14.9238 13.7015 14.5904C14.0349 14.257 14.2222 13.8048 14.2222 13.3333C14.2222 12.8618 14.0349 12.4096 13.7015 12.0762C13.3681 11.7428 12.9159 11.5555 12.4444 11.5555C11.9729 11.5555 11.5207 11.7428 11.1873 12.0762C10.8539 12.4096 10.6666 12.8618 10.6666 13.3333Z"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M0.888794 13.3333H10.6666"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.2222 13.3333H15.1111"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 2.66662C8 3.13811 8.1873 3.5903 8.5207 3.9237C8.8541 4.25709 9.30628 4.4444 9.77778 4.4444C10.2493 4.4444 10.7015 4.25709 11.0349 3.9237C11.3683 3.5903 11.5556 3.13811 11.5556 2.66662C11.5556 2.19512 11.3683 1.74294 11.0349 1.40954C10.7015 1.07614 10.2493 0.88884 9.77778 0.88884C9.30628 0.88884 8.8541 1.07614 8.5207 1.40954C8.1873 1.74294 8 2.19512 8 2.66662Z"
              stroke="currentColor"
              strokeWidth={1.3}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_24637_141">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
